import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Card, CardContent } from "./ui/card";
import { Sun, Wind, Zap, Cable, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const ServicesSection = () => {
  const [activeTab, setActiveTab] = useState("photovoltaique");

  const services = [
    {
      id: "photovoltaique",
      title: "Photovoltaïque",
      icon: Sun,
      description: "Produisez votre propre électricité et économisez jusqu'à 70%",
      detail:
        "Installez des panneaux solaires dernière génération et réduisez drastiquement vos factures d'électricité. Avec UM Groupe, bénéficiez d'une installation professionnelle, d'une garantie de 25 ans et d'un retour sur investissement garanti en moins de 7 ans. Plus de 3 000 installations réussies à travers la France.",
      image:
        "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3NjEwNjg0NTB8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      id: "climatisation",
      title: "Climatisation",
      icon: Wind,
      description: "Confort optimal toute l'année avec 60% d'économies",
      detail:
        "Nos climatisations réversibles A+++ chauffent en hiver et rafraîchissent en été, tout en consommant 3 fois moins qu'un chauffage électrique classique. Installation en moins de 24h, garantie 10 ans, maintenance incluse. Financement 0% disponible.",
      image:
        "https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxodmFjfGVufDB8fHx8MTc2MTA2ODQ1Nnww&ixlib=rb-4.1.0&q=85",
    },
    {
      id: "energie",
      title: "Contrats Énergie",
      icon: Zap,
      description: "Jusqu'à 30% d'économies sur vos contrats actuels",
      detail:
        "Nos experts négocient pour vous les meilleurs tarifs d'électricité et de gaz. Sans coupure, sans changement de compteur, juste des factures allégées. Analyse gratuite de vos contrats actuels et simulation d'économies instantanée. Plus de 2 000 entreprises et particuliers nous font confiance.",
      image:
        "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxlbmVyZ3l8ZW58MHx8fHwxNzYxMDY4NDY2fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      id: "fibre",
      title: "Fibre Optique",
      icon: Cable,
      description: "Internet ultra-rapide à prix imbattable garanti",
      detail:
        "Passez à la fibre optique avec des débits jusqu'à 8 Gb/s pour un prix fixe garanti sur 2 ans. Installation gratuite sous 7 jours, sans engagement de durée. Testez votre éligibilité et comparez avec votre offre actuelle en 30 secondes.",
      image:
        "https://images.unsplash.com/photo-1604869515882-4d10fa4b0492?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxmaWJlciUyMG9wdGljfGVufDB8fHx8MTc2MTA2ODQ3MXww&ixlib=rb-4.1.0&q=85",
    },
  ];

  const activeService = services.find((s) => s.id === activeTab);

  return (
    <section id="solutions" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-4">
            NOS SOLUTIONS CLÉ EN MAIN
          </h2>
          <p className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            4 Solutions pour <span className="text-emerald-600">Économiser Massivement</span>
          </p>
        </div>

        <p className="text-2xl md:text-3xl text-gray-700 text-center mb-16 max-w-4xl mx-auto leading-relaxed">
          Chaque solution est conçue pour <strong>maximiser vos économies</strong> tout en réduisant votre empreinte carbone.
          <br />
          <span className="text-blue-600 font-semibold">Installation professionnelle • Garantie étendue • Financement disponible</span>
        </p>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-4 gap-4 bg-transparent h-auto mb-12">
            {services.map((service) => {
              const Icon = service.icon;
              return (
                <TabsTrigger
                  key={service.id}
                  value={service.id}
                  className="data-[state=active]:bg-blue-600 data-[state=active]:text-white bg-white border-2 border-gray-200 hover:border-blue-300 transition-all py-4 px-6 rounded-lg text-base font-semibold"
                >
                  <Icon className="mr-2" size={20} />
                  {service.title}
                </TabsTrigger>
              );
            })}
          </TabsList>

          {services.map((service) => (
            <TabsContent key={service.id} value={service.id} className="mt-0">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div className="space-y-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-2xl">
                    <service.icon className="text-blue-600" size={32} />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900">{service.description}</h3>
                  <p className="text-lg text-gray-600 leading-relaxed">{service.detail}</p>
                  <Button
                    onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                    className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white border-0 rounded-lg group"
                  >
                    Commencer
                    <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
                  </Button>
                </div>
                <div className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-emerald-500 rounded-2xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity"></div>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="relative rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                  />
                </div>
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

export default ServicesSection;